// The only tab list per role (#307). The side menu on a wide screen and the phone menu both
// read from here, so a phone can never miss a tab the desktop shows.
// Labels use the glossary words: session, booking, student, instructor, review.
// The Messages tab label gains the unread count on the dashboards (messagesTabLabel, #333).
// Admin reads a conversation only from Reported conversations, while its report is open (#336).

export const DASHBOARD_TABS = {
  student: [
    { id: 'home', label: 'Home' },
    { id: 'bookings', label: 'My Bookings' },
    { id: 'book', label: 'Book a session' },
    { id: 'profile', label: 'Profile' },
    { id: 'messages', label: 'Messages' },
  ],
  instructor: [
    { id: 'home', label: 'Home' },
    { id: 'schedule', label: 'Schedule' },
    { id: 'requests', label: 'Requests' },
    { id: 'bookings', label: 'Bookings' },
    { id: 'students', label: 'Students' },
    { id: 'reviews', label: 'Reviews' },
    { id: 'payments', label: 'Payments' },
    { id: 'profile', label: 'Profile' },
    { id: 'messages', label: 'Messages' },
  ],
  admin: [
    { id: 'overview', label: 'Overview' },
    { id: 'users', label: 'Users' },
    { id: 'instructors', label: 'Instructors' },
    { id: 'applications', label: 'Applications' },
    { id: 'bookings', label: 'Bookings' },
    { id: 'booking-payments', label: 'Booking payments' },
    { id: 'reported', label: 'Reported conversations' },
    { id: 'blog', label: 'Blog Posts' },
    { id: 'activity', label: 'Activity Log' },
    { id: 'errors', label: 'Error Log' },
    { id: 'system', label: 'Server Health' },
  ],
};

// The label of one tab, for headings that name the open tab.
export const tabLabel = (tabs, id) => tabs.find((t) => t.id === id)?.label;
